// src/hooks/products/useDeleteAllProducts.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllProducts } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useDeleteAllProducts = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllProductsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteAllProducts,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete products");
        },
    });

    return {
        deleteAllProducts: deleteAllProductsMutate,
        isDeleteAll: isPending || isLoading,
    };
};

export default useDeleteAllProducts;
